module.exports = {"pageTitleText":"Notification Channels","createText":"Add Channel","channelName":"Channel Name","channelType":"Channel Type","channelTelegramBotToken":"Bot Token","channelLineBotToken":"Channel Access Token","channelSendTo":"Send To","channelTest":"Test","sections":{"essential":"Essential"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/notificationChannels.json
// module id = XzKI
// module chunks = 3